import { FC, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { Page401 } from './page-401';

export const PageUnauthorized: FC = () => {
    const { search } = useLocation();

    const message = useMemo(() => {
        const params = new URLSearchParams(search);
        return params.get('message') ?? 'Unauthorized';
    }, [search]);

    return <Page401 title="No Access" message={message} />;
};
